import { createSelector } from '@ngrx/store';
import { MakeChangeState } from '../reducers/cir.reducer';

const CIR_FEATURE_KEY = 'cir';

export const selectWorkspaceTypes = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.workspaceTypes,
);

export const selectReviewLocations = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.reviewLocations,
);

export const selectSites = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.sites,
);

export const selectLoading = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.loading,
);

export const selectError = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.error,
);

export const selectStudyId = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.study,
);
export const selectStudyName = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.studyName,
);
export const selectSingleSiteId = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.site,
);

export const selectWorkspaceType = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.workspaceType,
);

export const selectSitesData = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.sitesData,
);

export const selectReviewLocationType = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.reviewLocationtype,
);

export const selectStudyHasAccesss = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.studyHasAccess,
);

export const selectTotalSites = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.totalSites,
);

export const selectSiteLoaded = createSelector(
  (state: { [CIR_FEATURE_KEY]: MakeChangeState }) => state[CIR_FEATURE_KEY],
  (state) => state.siteLoaded,
);
